import styled from 'styled-components';

const Backdrop = styled.button`
    background: var(--container-background-color-backdrop);
    cursor: url('data:image/svg+xml,%3Csvg%20width%3D%2240%22%20height%3D%2240%22%20viewBox%3D%220%200%2040%2040%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cmask%20id%3D%22mask0_20_2804%22%20style%3D%22mask-type%3Aalpha%22%20maskUnits%3D%22userSpaceOnUse%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2240%22%20height%3D%2240%22%3E%3Crect%20width%3D%2240%22%20height%3D%2240%22%20fill%3D%22%23D9D9D9%22%20%2F%3E%3C%2Fmask%3E%3Cg%20mask%3D%22url%28%23mask0_20_2804%29%22%3E%3Cpath%20d%3D%22M6.4%2019L5%2017.6L10.6%2012L5%206.4L6.4%205L12%2010.6L17.6%205L19%206.4L13.4%2012L19%2017.6L17.6%2019L12%2013.4L6.4%2019Z%22%20fill%3D%22%23FFFFFF%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E'),
        pointer;
    pointer-events: fill;
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: var(--z-index-modal-backdrop);
    top: 0;
    left: 0;
`;

export default Backdrop;
